import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { registerLocaleData } from '@angular/common';
import localeZA from '@angular/common/locales/en-ZA';

registerLocaleData(localeZA, 'en-ZA');

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { PageComponent } from './components/page/page.component';
import { CarouselComponent } from './components/carousel/carousel.component';
import { LocationThumbComponent } from './components/location-thumb/location-thumb.component';
import { LocationPageComponent } from './pages/location-page/location-page.component';
import { TestimonialComponent } from './components/testimonial/testimonial.component';
import { ReasonsToLoveComponent } from './components/reasons-to-love/reasons-to-love.component';
import { LinkBlockComponent } from './components/link-block/link-block.component';
import { SelectUnitPageComponent } from './pages/select-unit-page/select-unit-page.component';
import { ReservationComponent } from './components/reservation/reservation.component';
import { PopupComponent } from './components/popup/popup.component';
import { UnitReservedPageComponent } from './pages/unit-reserved-page/unit-reserved-page.component';
import { MetaService } from 'services/meta.service';
import { TestimonialService } from 'services/testimonial.service';
import { UnitService } from 'services/unit.service';
import { OTPService } from 'services/otp.service';
import { LocationService } from 'services/location.service';
import { AutofocusDirective } from './directives/autofocus.directive';
import { SiteTourComponent } from './components/site-tour/site-tour.component';
import { MenuComponent } from './components/menu/menu.component';
import { MapComponent } from './components/map/map.component';
import { DateComponent } from './components/date/date.component';
import { ForeignNationalPageComponent } from './pages/foreign-national-page/foreign-national-page.component';
import { FacilityStandardsPageComponent } from './pages/facility-standards-page/facility-standards-page.component';
import { SecurityPageComponent } from './pages/security-page/security-page.component';
import { MovingTipsPageComponent } from './pages/moving-tips-page/moving-tips-page.component';
import { FaqsPageComponent } from './pages/faqs-page/faqs-page.component';
import { MenuButtonComponent } from './components/menu-button/menu-button.component';
import { UnitDropdownComponent } from './components/unit-dropdown/unit-dropdown.component';
import { ContactPageComponent } from './pages/contact-page/contact-page.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { PaymentTermsPageComponent } from './pages/payment-terms-page/payment-terms-page.component';
import { FreeMovePageComponent } from './pages/free-move-page/free-move-page.component';
import { PrivacyStatementPageComponent } from './pages/privacy-statement-page/privacy-statement-page.component';
import { WrongRoutePageComponent } from './pages/wrong-route-page/wrong-route-page.component';
import { CareersPageComponent } from './pages/careers-page/careers-page.component';
import { CaptchaComponent } from './components/captcha/captcha.component';
import { BlogPageComponent } from './pages/blog-page/blog-page.component';
import { ArticlePageComponent } from './pages/article-page/article-page.component';
import { VipPageComponent } from './pages/vip-page/vip-page.component';
import { NearbySuburbsComponent } from './components/nearby-suburbs/nearby-suburbs.component';
import { FooterComponent } from './components/footer/footer.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { ReferAFriendPageComponent } from './pages/refer-a-friend-page/refer-a-friend-page.component';
import { BannerComponent } from './components/banner/banner.component';
import { BoxBannerComponent } from './components/box-banner/box-banner.component';
import { TopBannersComponent } from './components/top-banners/top-banners.component';
import { UnitGridGroupedBComponent } from './components/unit-grid-grouped-b/unit-grid-grouped-b.component';
import { EbookMovingChecklistPageComponent } from './pages/ebook-moving-checklist-page/ebook-moving-checklist-page.component';
import { EbookGetMoreSpacePageComponent } from './pages/ebook-get-more-space-page/ebook-get-more-space-page.component';
import { RentNowPageComponent } from './pages/rent-now-page/rent-now-page.component';
import { VideoBannerComponent } from './components/video-banner/video-banner.component';
import { ImageBannerComponent } from './components/image-banner/image-banner.component';
import { MiniBannerComponent } from './components/mini-banner/mini-banner.component';
import { UnitInteractiveViewComponent } from './components/unit-interactive-view/unit-interactive-view.component';
import { StandAloneInteractiveViewBannerComponent } from './components/stand-alone-interactive-view-banner/stand-alone-interactive-view-banner.component';
import { FurnitureStoragePageComponent } from './pages/furniture-storage-page/furniture-storage-page.component';
import { CarStorageUnitsAndParkingBaysPageComponent } from './pages/car-storage-units-and-parking-bays-page/car-storage-units-and-parking-bays-page.component';
import { UnitLoadingComponent } from './components/unit-loading/unit-loading.component';
import { WhatsappTestPageComponent } from './pages/whatsapp-test-page/whatsapp-test-page.component';
import { HatfieldCompetitionBannerComponent } from './components/hatfield-competition-banner/hatfield-competition-banner.component';

@NgModule({ declarations: [
        AppComponent,
        HomePageComponent,
        PageComponent,
        CarouselComponent,
        LocationThumbComponent,
        LocationPageComponent,
        TestimonialComponent,
        ReasonsToLoveComponent,
        LinkBlockComponent,
        SelectUnitPageComponent,
        ReservationComponent,
        PopupComponent,
        UnitReservedPageComponent,
        AutofocusDirective,
        SiteTourComponent,
        MenuComponent,
        MapComponent,
        DateComponent,
        ForeignNationalPageComponent,
        FacilityStandardsPageComponent,
        SecurityPageComponent,
        MovingTipsPageComponent,
        FaqsPageComponent,
        MenuButtonComponent,
        UnitDropdownComponent,
        ContactPageComponent,
        SpinnerComponent,
        PaymentTermsPageComponent,
        FreeMovePageComponent,
        PrivacyStatementPageComponent,
        WrongRoutePageComponent,
        CareersPageComponent,
        CaptchaComponent,
        BlogPageComponent,
        ArticlePageComponent,
        VipPageComponent,
        NearbySuburbsComponent,
        FooterComponent,
        DropdownComponent,
        ReferAFriendPageComponent,
        BannerComponent,
        BoxBannerComponent,
        TopBannersComponent,
        UnitGridGroupedBComponent,
        EbookMovingChecklistPageComponent,
        EbookGetMoreSpacePageComponent,
        RentNowPageComponent,
        VideoBannerComponent,
        ImageBannerComponent,
        MiniBannerComponent,
        UnitInteractiveViewComponent,
        StandAloneInteractiveViewBannerComponent,
        FurnitureStoragePageComponent,
        CarStorageUnitsAndParkingBaysPageComponent,
        UnitLoadingComponent,
        WhatsappTestPageComponent,
        HatfieldCompetitionBannerComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule.withServerTransition({ appId: 'serverApp' }),
        FormsModule,
        AppRoutingModule], providers: [TestimonialService, UnitService, OTPService, LocationService, MetaService, provideHttpClient(withInterceptorsFromDi(), withJsonpSupport())] })
export class AppModule { }
